export default __webpack_public_path__ + "static/media/edo-principes.229fea71.svg";